import { render, staticRenderFns } from "./close.vue?vue&type=template&id=ec8935c0&scoped=true&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"
import style0 from "./close.vue?vue&type=style&index=0&id=ec8935c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8935c0",
  null
  
)

export default component.exports